import React from 'react'
import { connect } from 'react-redux'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { deleteTheme, listThemes } from '../state/actions'
import N from 'utils-support/navigation'
import { GETThemesResponseRow, ITheme } from '@cbgms/api/modules/themes'
import { RowHeight } from '@cbgms/components/grid/Types'

interface Props {
  deleteTheme: (ThemeUUID: string, dryRun: boolean) => void
}
export const onAdd = () => {
  N.push('/themes/new')
}

export const onEdit = (data: { Theme: ITheme }) => {
  N.push(`/themes/edit/${data.Theme.UUID}`)
}

const enhance = connect(null, { deleteTheme })
export class ThemesList extends React.PureComponent<Props, {}> {
  onDelete = async (row: GETThemesResponseRow, dryRun: boolean): Promise<any> => {
    return this.props.deleteTheme(row.Theme.UUID, dryRun)
  }

  render() {
    return (
      <SupportListWrapper
        scope='themes'
        rowHeight={RowHeight.Large}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={this.onDelete}
        loadAction={listThemes}
        translationKey='theme'
      />
    )
  }
}
export default enhance(ThemesList)
